
import { Options, mixins } from "vue-class-component";
import CartService from "../../service/CartService.js";
import PosService from "../../service/PosService.js";
import Toaster from "../../helpers/Toaster";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import UtilityOptions from "../../mixins/UtilityOptions";
import moment from "moment";
import CashierSession from "../../service/CashierSession";
import FooterService from "../../service/footerService.js";
import router from "../../router";
import Calendar from "primevue/calendar";

@Options({
    title: "Token Queue",
    components: { PaymentScreen, Calendar },
})
export default class TokenQueue extends mixins(UtilityOptions) {
    private cartService;
    private posService;
    private toast;
    private lists: any[]       = [];
    private keyword            = "";
    private paymentDialog      = false;
    private currentCart: any   = null;
    private currentDisplayNumber = 0;
    private home = { icon: "pi pi-home", to: "/" };
    private breadcrumbs = [{ label: "Token Queue", to: "/pos-token-queue" }];
    private storeName = "Loading...";
    private cashierService;
    private conflictPopup        = false;
    private conflictMessage      = '';
    private cancelConfirmPopup   = false;
    private selectedDate: Date = new Date();   
    private selectedStatusType = 1; 
    private goToFirstLink    = 0;
    private goToSubFirstLink = 0;
    private checkPagination  = true;
    private totalRecords     = 0;
    private limit            = 13;
    private _beaconHandler: () => void = () => {};
    private _visibilityHandler: () => void = () => {};
    private allLists: any[] = [];
    private _pollInterval: any = null;
    private _pollPaused = false;
    private tokenHistoryDialog = false;
    private historyToken: any = null;
    private currentPage = 0;
    private validationPopupMessage = '';
    private validationPopup = false;

    private statusTypes = [
        { key: 0, name:"All"},
        { key: 1, name:"Tokenized"},
        { key: 2, name:"Payment"},
        { key: 3, name:"Completed"},
        { key: 4, name:"Cancelled"},

    ];

   get pendingCount() {
        return this.allLists.filter(t => t.status === 1).length;
    }

    get completedCount() {
        return this.allLists.filter(t => t.status === 3).length;
    }

    get selectedDateLabel() {
        return moment(this.selectedDate).format('DD MMM YYYY');
    }

    get isViewingToday() {
        return moment(this.selectedDate).isSame(moment(), 'day');
    }

    get totalIssuedCount() {
        return this.lists.length;
    }

    created() {
        this.cartService = new CartService();
        this.posService  = new PosService();
        this.toast       = new Toaster();
        this.cashierService = new CashierSession();
    }

    mounted() {

        const footerService = new FooterService();
        footerService.branchDetail().then((res) => {
            if (res.store_info) {
                this.storeName = res.store_info.name;
            }
        });
        this.loadList();
        this.startPolling();

        setTimeout(() => {
            const el = document.getElementById('token-search');
            if (el) el.focus();
        }, 200);

        window.addEventListener('keydown', this.handleKeydown);

        this._beaconHandler = () => {
            if (this.currentCart?.id) {
                const url = '/beacon/revert_token';
                const data = JSON.stringify({ cart_id: this.currentCart.id });
                navigator.sendBeacon(url, new Blob([data], { type: 'application/json' }));
            }
        };

        this._visibilityHandler = () => {
            if (document.visibilityState === 'visible') {
                this.loadList();
                this.startPolling();
            }
        };

        window.addEventListener('pagehide', this._beaconHandler);
        window.addEventListener('beforeunload', this._beaconHandler); 
        window.addEventListener('visibilitychange', this._visibilityHandler);
    }

    startPolling() {
        this.stopPolling(); 
        this._pollInterval = setInterval(() => {
            if (!this.paymentDialog && !this.conflictPopup && !this.cancelConfirmPopup) {
                this.loadList();
            }
        }, 15000); 
    }

    stopPolling() {
        if (this._pollInterval) {
            clearInterval(this._pollInterval);
            this._pollInterval = null;
        }
    }

    beforeUnmount() {
        this.stopPolling();
        window.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('pagehide', this._beaconHandler);
        window.removeEventListener('beforeunload', this._beaconHandler); 
        window.removeEventListener('visibilitychange', this._visibilityHandler);
    }

    handleKeypress(event) {
        if (event.key === 'Enter' && this.keyword) {
            this.searchToken();
        }
    }

    handleKeydown(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.redirectTokenQueue();
        }
        if (event.key === 'End') {
            event.preventDefault();
            this.logoutCashier();
        }else if (this.validationPopup) {
            if (event.key === "Escape") {
                event.preventDefault();
                this.closeValidationPopup();
                return;
            }
        }
    }

    closeValidationPopup() {
        this.validationPopup = false;
    }

    redirectTokenQueue() {
        router.replace({ path: '/pos-token' });
    }

    redirectHome() {
        router.replace({ path: '/home/dashboard' });
    }

    logoutCashier() {
        const answer = window.confirm('Do you want to logout from Cashier Session?');
        if (answer) {
            this.cashierService.logoutCashier().then((res) => {
                if (res.status_id == 1) {
                    this.toast.showInfo(res.msg);
                    this.store.dispatch(ActionTypes.CASHIER_SESSION, '');
                    router.push({ path: '/home/dashboard' });
                } else {
                    this.toast.handleResponse(res);
                    router.push({ path: '/home/dashboard' });
                }
            });
        }
    }

   loadList(page = 0, filterKeyword: string = '') {
        const dateStr = moment(this.selectedDate).format('YYYY-MM-DD');
        const kw = filterKeyword || this.keyword;

        this.cartService.tokenList('', 0, dateStr).then((data) => {
            if (data && data.records) {
                this.allLists = data.records;
                this.lists = data.records.filter((r: any) => {
                    const matchesStatus = this.selectedStatusType === 0 || r.status === this.selectedStatusType;
                    const matchesKeyword = !kw || 
                        (r.token_number ?? '').toLowerCase().includes(kw.toLowerCase()) ||
                        (r.display_number?.toString() ?? '').includes(kw) ||
                        (r.customer_name ?? '').toLowerCase().includes(kw.toLowerCase());
                    return matchesStatus && matchesKeyword;
                });
                this.totalRecords = this.lists.length;
                const maxPage = Math.max(0, Math.ceil(this.lists.length / this.limit) - 1);
                const safePage = Math.min(this.currentPage, maxPage);
                this.goToFirstLink = safePage * this.limit;
            }
        });
    }

    searchToken() {
        if (!this.keyword.trim()) return;

        const kw = this.keyword.trim().toLowerCase();

        const match = this.allLists.find(t =>
            (t.token_number ?? '').toLowerCase() === kw ||
            (t.display_number?.toString() ?? '') === kw
        );

        if (match) {
            const status = Number(match.status);
            if (status === 2) {
                this.toast.showInfo(`Token ${String(match.display_number)} is currently being processed. Please wait.`);
                this.keyword = '';
                return;
            }
            if (status === 3) {
                this.toast.showInfo(`Token ${String(match.display_number)} has already been paid and completed.`);
                const searchKw = this.keyword;
                this.selectedStatusType = 0;
                this.keyword = '';
                this.loadList(0, searchKw);
                return;
            }
            if (status === 4) {
                this.toast.showInfo(`Token ${String(match.display_number)} was cancelled and is no longer active.`);
                const searchKw = this.keyword;
                this.selectedStatusType = 0;
                this.keyword = '';
                this.loadList(0, searchKw);
                return;
            }
            this.loadCart(this.keyword.trim());
            return;
        }

        this.cartService.loadByToken(this.keyword.trim()).then((res) => {
            if (!res || res.alert === 'error') {
                this.toast.showInfo('Token not found. Please check the token number.');
                this.keyword = '';
                return;
            }

            if (res.alert === 'warning') {
                if (res.token_date) {
                    const searchKw = this.keyword;
                    this.selectedDate = new Date(res.token_date);
                    this.selectedStatusType = 0; 
                    this.keyword = '';
                    this.loadList(0, searchKw);
                } else {
                    this.keyword = '';
                }
                this.toast.showInfo(res.msg || 'Token is not active.');
                return;
            }

            if (res.alert === 'info') {
                if (res.cart?.token_date) {
                    const searchKw = this.keyword;
                    this.selectedDate = new Date(res.cart.token_date);
                    this.selectedStatusType = 0; 
                    this.keyword = '';
                    this.loadList(0, searchKw);
                }
                this.currentCart = res.cart;
                this.currentDisplayNumber = res.cart.display_number;
                const total = res.cart.items.reduce(
                    (sum: number, item: any) => sum + Number(item.sub_total), 0
                );
                this.store.dispatch(ActionTypes.TOTAL_BILL, Number(total.toFixed(2)));
                this.paymentDialog = true;
            }
        });
    }

    loadCart(tokenNumber: string) {
        this.cartService.loadByToken(tokenNumber).then((res) => {
            if (!res) {
                this.toast.showInfo('Token not found. Please check the token number.');
                this.keyword = '';
                return;
            }
            if (res.alert === 'info') {
                this.currentCart          = res.cart;
                this.currentDisplayNumber = res.cart.display_number;
                const total = res.cart.items.reduce(
                    (sum: number, item: any) => sum + Number(item.sub_total), 0
                );
                this.store.dispatch(ActionTypes.TOTAL_BILL, Number(total.toFixed(2)));
                this.paymentDialog = true;
                this.loadList();

            } else if (res.alert === 'warning' || res.alert === 'error') {
                this.toast.showInfo(res.msg || 'Token not found. Please check the token number.');
                this.keyword = '';
            }

        });
    }

    clearSearch() {
        this.keyword = '';
        this.loadList();
    }

    closePaymentScreen() {
        if (this.currentCart) {
            this.cartService.revertToTokenised(this.currentCart.id).then(() => {
                this.loadList();
            });
        }
        this.paymentDialog = false;
        this.currentCart   = null;
    }

    getTotalPaid(paymentList: any[]) {
        let totalPaid = 0, totalTendered = 0, totalChange = 0;
        paymentList.forEach((e) => {
            if (e.paymentType !== 'Tip') {
                totalPaid     += Number(e.transTotalAmount);
                totalTendered += Number(e.tendered);
                totalChange   += Number(e.change);
            }
        });
        return [totalPaid, totalTendered, totalChange];
    }

    getPaymentMethod(paymentList: any[]) {
        if (paymentList.length === 0)  return 'Pay Later';
        if (paymentList.length === 1)  return paymentList[0].paymentType;
        return 'Split';
    }

    getTotalPaidCash(paymentList: any[]) {
        return paymentList
            .filter((e) => e.paymentType === 'Cash')
            .reduce((s, e) => s + Number(e.transTotalAmount), 0);
    }

    getTotalPaidBank(paymentList: any[]) {
        return paymentList
            .filter((e) => e.paymentType !== 'Cash')
            .reduce((s, e) => s + Number(e.transTotalAmount), 0);
    }

    calculateTotals(itemList: any[], cart: any) {
        let totalGross = 0, totalCost = 0;
        let totalTax1 = 0, totalTax2 = 0, totalTax3 = 0;
        let itemDiscTotal = 0;

        itemList.forEach((e) => {
            const lineGross = e.sellingPrice * e.unit;
            const lineDisc  = (lineGross / 100) * e.itemDisc;
            const afterDisc = lineGross - lineDisc;

            totalGross    += lineGross;
            totalCost     += e.purchasePrice * e.unit;
            itemDiscTotal += lineDisc;
            totalTax1     += (afterDisc / 100) * e.tax1;
            totalTax2     += (afterDisc / 100) * e.tax2;
            totalTax3     += (afterDisc / 100) * e.tax3;
        });

        const invoiceDiscount = Number(cart.invoice_discount) || 0;
        const discType        = cart.disc_type || 'Flat';
        let invoiceDiscAmt    = 0;

        if (invoiceDiscount > 0) {
            const afterItemDisc = totalGross - itemDiscTotal;
            invoiceDiscAmt = discType === 'Flat'
                ? invoiceDiscount
                : (afterItemDisc / 100) * invoiceDiscount;
        }

        const totalDiscAmount = itemDiscTotal + invoiceDiscAmt;
        const totalTax        = Number((totalTax1 + totalTax2 + totalTax3).toFixed(2));
        const netTotal        = Number((totalGross - totalDiscAmount + totalTax).toFixed(2));

        return {
            totalGross, totalCost, totalTax1, totalTax2, totalTax3,
            totalDiscAmount, invoiceDiscount, discType, totalTax, netTotal,
        };
    }

    buildAccountingEntries(
        paymentList: any[],
        totals: ReturnType<typeof this.calculateTotals>
    ) {
        const { totalGross, totalTax1, totalTax2, totalTax3,
                totalDiscAmount, totalTax, netTotal } = totals;

        const totalPaidCash = this.getTotalPaidCash(paymentList);
        const totalPaidBank = this.getTotalPaidBank(paymentList);
        const [totalPaid]   = this.getTotalPaid(paymentList);
        const totalBalance  = netTotal - totalPaid;

        const entries: any[] = [];

        if (totalBalance === 0) {
            if (totalPaidCash > 0) entries.push({ accountID: 2, accountHead: 'Cash in hand',        amount: totalPaidCash, type: 'Debit' });
            if (totalPaidBank > 0) entries.push({ accountID: 8, accountHead: 'Cash at bank',         amount: totalPaidBank, type: 'Debit' });
        } else if (totalBalance === netTotal) {
            entries.push({ accountID: 4, accountHead: 'Accounts receivable', amount: netTotal,       type: 'Debit' });
        } else if (totalBalance > 0 && totalPaid > 0) {
            if (totalPaidCash > 0) entries.push({ accountID: 2, accountHead: 'Cash in hand',        amount: totalPaidCash, type: 'Debit' });
            if (totalPaidBank > 0) entries.push({ accountID: 8, accountHead: 'Cash at bank',         amount: totalPaidBank, type: 'Debit' });
            entries.push({ accountID: 4, accountHead: 'Accounts receivable', amount: totalBalance,   type: 'Debit' });
        }

        entries.push({ accountID: 48, accountHead: 'Sales Revenue', amount: totalGross - totalDiscAmount, type: 'Credit' });

        if (totalTax1 > 0) entries.push({ accountID: 0, accountHead: 'Tax 1', amount: totalTax1, type: 'Credit' });
        if (totalTax2 > 0) entries.push({ accountID: 0, accountHead: 'Tax 2', amount: totalTax2, type: 'Credit' });
        if (totalTax3 > 0) entries.push({ accountID: 0, accountHead: 'Tax 3', amount: totalTax3, type: 'Credit' });

        return entries;
    }

    printReceipt(htmlTemplate: string) {
        const pw = window.open('', '_blank');
        if (pw) {
            pw.document.open();
            pw.document.write(`
                <html><head><title>Receipt</title></head>
                <body onload="setTimeout(function(){ window.print(); window.close(); }, 300)">
                    ${htmlTemplate}
                </body></html>
            `);
            pw.document.close();
        }
    }

    processPayment(paymentList: any[]) {
        if (!this.currentCart) return;

        const cart = this.currentCart;

        const itemList = cart.items.map((item: any) => ({
            stockID:       item.stock_id,
            productID:     item.product_id,
            productName:   item.product_name,
            batchNo:       item.batch_no,
            mode:          item.mode,
            sellingPrice:  Number(item.selling_price),
            mrp:           Number(item.mrp),
            purchasePrice: Number(item.purchase_price),
            tax1:          Number(item.tax_1),
            tax2:          Number(item.tax_2),
            tax3:          Number(item.tax_3),
            unit:          Number(item.requested_qty),
            freeUnit:      Number(item.free_qty),
            itemDisc:      Number(item.item_disc),
            subTotal:      Number(item.sub_total),
            packSize:      Number(item.pack_size),
            sheetSize:     Number(item.strip_size),
            totalUnit:     Number(item.total_unit),
            expiryDate:    item.expiry_date,
            supplierBonus: 0,
        }));

        const totals = this.calculateTotals(itemList, cart);
        const [totalPaid, totalTendered, totalChange] = this.getTotalPaid(paymentList);

        const itemData = {
            id:              0,
            profileID:       cart.customer_id || 1,
            discount:        Number(totals.totalDiscAmount.toFixed(2)),
            totalPaid:       Number(totalPaid.toFixed(2)),
            totalTendered:   Number(totalTendered.toFixed(2)),
            totalChange:     Number(totalChange.toFixed(2)),
            totalGrossAmt:   Number(totals.totalGross.toFixed(2)),
            invoiceDiscount: totals.invoiceDiscount,
            discType:        totals.discType,
            totalCost:       Number(totals.totalCost.toFixed(2)),
            totalBill:       totals.netTotal,
            totalTax1:       Number(totals.totalTax1.toFixed(2)),
            totalTax2:       Number(totals.totalTax2.toFixed(2)),
            totalTax3:       Number(totals.totalTax3.toFixed(2)),
            totalTax:        totals.totalTax,
            description:     cart.description    || '',
            paymentMethod:   this.getPaymentMethod(paymentList),
            doctorDetails:   cart.doctor_details  || '',
            patientDetails:  cart.patient_details || '',
            searchReceiptNo: '',
            status:          'Active',
            type:            'INE',
            initiatedBranchId: cart.branch_id, 
        };

        const state = {
            selectedProfile: cart.customer_name || '',
            customerTel:     cart.customer_tel  || '',
            chippedProfile:  [],
            chippedTel:      [],
            transferStoreID: '',
        };

        const counterEntry = this.buildAccountingEntries(paymentList, totals);

        this.posService
            .saveItem(itemData, paymentList, state, itemList, counterEntry, true, cart.branch_id )
            .then((res) => {

                if (res.alert === 'frozen') {
                    const frozenMsg  = res.msg;
                    const cartId     = this.currentCart?.id;   

                    this.paymentDialog = false;
                    this.currentCart   = null;

                    if (cartId) {
                        this.cartService.revertToTokenised(cartId).then(() => {
                            this.loadList();
                        });
                    }

                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.validationPopupMessage = frozenMsg;
                            this.validationPopup = true;
                        }, 150);
                    });

                    return;
                }

                if (res.alert === 'conflict') {
                    this.conflictMessage =
                        `Stock for "${res.productName}" has changed. ` +
                        `Only ${res.available} units are now available. ` +
                        `Click OK to go back and adjust the order, or Cancel Order to abandon it.`;
                    this.conflictPopup = true;
                    return;
                }

                if (res.alert === 'info') {
                    this.paymentDialog = false;
                    this.cartService.completeCart(cart.id);
                    this.toast.showSuccess(
                        'Payment complete - Token ' + 
                        String(cart.display_number)
                    );
                    if (res.htmlTemplate) {
                        this.printReceipt(res.htmlTemplate);
                    }
                    this.currentCart = null;
                    this.keyword     = '';
                    this.loadList();
                } else {
                    this.toast.showError(res.msg || 'Payment failed. Please try again.');
                }
            })
            .catch((err) => {
                console.error('Payment processing error:', err);
                this.toast.showError('An unexpected error occurred during payment processing. Please try again.');
            });
    }

    reprintSlip(cartId: number) {
        this.cartService.reprintSlip(cartId).then((res) => {
            if (res.slip_html) {
                const pw = window.open('', '_blank');
                if (pw) {
                    pw.document.open();
                    pw.document.write(`
                        <html><head><title>Token Slip</title></head>
                        <body onload="setTimeout(function(){
                            window.print();window.close();
                        },400)">
                            ${res.slip_html}
                        </body></html>
                    `);
                    pw.document.close();
                }
            }
        });
    }

    cancelToken(cartId: number) {
        if (!confirm('Cancel this token?')) return;
        this.cartService.canceledCart(cartId).then((res) => {
            this.toast.handleResponse(res);
            this.loadList();
        });
    }

    formatTime(dateStr: string) {
        return moment(dateStr).format('hh:mm A');
    }

    get progressBar() {
        return this.store.getters.getProgressBar;
    }

    onConflictOk() {
        this.conflictPopup = false;
        if (this.currentCart) {
            this.cartService.revertToTokenised(this.currentCart.id).then(() => {
                this.loadList();
            });
        }
        this.paymentDialog = false;
        this.currentCart   = null;
    }

    onConflictCancel() {
        this.conflictPopup     = false;
        this.cancelConfirmPopup = true;
    }

    onCancelConfirmNo() {
        this.cancelConfirmPopup = false;
        this.conflictPopup      = true;
    }

    onCancelConfirmYes() {
        this.cancelConfirmPopup = false;
        this.paymentDialog      = false;

        if (this.currentCart) {
            this.cartService.canceledCart(this.currentCart.id).then(() => {
                this.toast.showInfo(
                    'Token ' + String(this.currentCart?.display_number || '') +
                    ' has been cancelled.'
                );
                this.currentCart = null;
                this.keyword     = '';
                this.loadList();
            });
        }
    }

    editCart(cartId: number) {
        const url = `/pos?cart_id=${cartId}&mode=edit`;
        window.open(url, '_blank');
    }

    onDateChange() {
        this.keyword = '';
        this.loadList();
    }

    get currency() {
        return this.store.getters.getCurrency;
    }

    showHistory(data: any) {
        this.historyToken = data;
        this.tokenHistoryDialog = true;
    }

    get tokenActivityRows() {
        if (!this.historyToken?.activity_logs) return [];

        return this.historyToken.activity_logs.map(log => ({
            event: log.event.toUpperCase(),
            statusClass: log.event,
            by: log.user?.name || '-',
            time: this.formatTime(log.created_at),
            total: log.total,
            items: log.items_snapshot || [],
        }));
    }

    getStatusUser(token: any) {
        if (!token?.activity_logs) return '-';

        const logs = [...token.activity_logs].reverse();

        if (token.status === 1) {
            const reissuedLog = logs.find(l => l.event === 'reissued');
            if (reissuedLog) return reissuedLog?.user?.name || '-';

            const issuedLog = logs.find(l => l.event === 'issued');
            return issuedLog?.user?.name || '-';
        }

        if (token.status === 2) {
            const log = logs[0];
            return log?.user?.name || '-';
        }

        const statusEventMap = {
            3: 'completed',
            4: 'canceled'
        };

        const targetEvent = statusEventMap[token.status];

        const log = logs.find(l => l.event === targetEvent);

        return log?.user?.name || '-';
    }

    onPageChange(event: any) {
        this.currentPage = event.page;
    }
}
